export const MuiFormHelperText = {
    styleOverrides: {
        root: {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0.4px",
            "&.Mui-error::before": {
                font: "var(--fa-font-regular)",
                content: "'\\f06a'",
                marginRight: "4px"
            },
            "&.Mui-warning::before": {
                font: "var(--fa-font-regular)",
                content: "'\\f071'",
                marginRight: "4px"
            }
        }
    }
};
//# sourceMappingURL=FormHelperText.js.map